import React from 'react'

export default function ValidInvalid({ boolean }) {
    return (
        <span>
            {boolean ? '✓' : '❌'}
        </span>
    )
}
